export default "assets/images/da8627e764ecd1a7197091ca77ac5b67.png";